import Home from './Home.svelte';

const app = new Home({
    target: document.body
});

export default app;